import React from "react";
import {useRef, useState} from "react";
import {useNavigate} from "react-router-dom";

import {ReviewFooter} from "../../../layout/Footer/Footer";

import {getImageUrl} from "../../../utils/images";
import {showMessage, showSpinner} from "../../../utils/alerts";
import {checkValidOtpandpassword} from "../../../service/onboardingService";
import Swal from "sweetalert2";
import {showMessageCustom} from "../../../utils/alertwithcustomfunc";

export const ForgotPasswordEnterCode = (firstTimeLogin) => {
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState("");

    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [confirmError, setConfirmError] = useState("");
    const [shownewpassword, setShownewpassword] = useState(false);
    const [showconfirmpassword, setShowconfirmpassword] = useState(false);
    const [input1, setInput1] = useState("");
    const [input2, setInput2] = useState("");
    const [input3, setInput3] = useState("");
    const [input4, setInput4] = useState("");
    const [input5, setInput5] = useState("");
    const [input6, setInput6] = useState("");
    const [input7, setInput7] = useState("");
    const [otpValue, setOtpValue] = useState("");

    const [policies, setPolicies] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        digit: false,
        special: false,
    });

    const validatePassword = (password) => {
        const updatedPolicies = {
            length: password.length >= 8,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            digit: /[0-9]/.test(password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        };
        setPolicies(updatedPolicies);

        const allValid = Object.values(updatedPolicies).every(Boolean);
        return allValid;
    };

    const handleNewPasswordChange = (e) => {
        const password = e.target.value;
        setNewPassword(password);

        if (!validatePassword(password)) {
            setPasswordError("Your password must meet the following criteria:");
        } else {
            setPasswordError("");
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const password = e.target.value;
        setConfirmPassword(password);

        if (password !== newPassword) {
            setConfirmError("The new password and confirm password do not match.");
        } else {
            setConfirmError("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        showSpinner("Updating", "Your password update is in progress. Please wait...");

        if (!validatePassword(newPassword)) {
            setPasswordError("Your password must meet the following criteria:");
            setIsLoading(false);
            return;
        }

        if (newPassword !== confirmPassword) {
            setConfirmError("The new password and confirm password do not match.");
            setIsLoading(false);
            return;
        }

        try {
            const response = await checkValidOtpandpassword(otpValue, confirmPassword);
            if (response.status === 200 && response.data === "Password updated successfully") {
                setIsLoading(false);
                Swal.close();
                showMessageCustom(
                    "Your password has been updated successfully.",
                    "Please proceed to login with your new password",
                    () => {
                        window.location.href = `${window.location.origin}/login-page`;
                    }
                );

                return;
            } else if (response.status === 200 && response.data === "Password update failed due to an internal error") {
                showMessage(
                    "Your new password cannot be the same as your current password.",
                    " Please choose a different password."
                );
            } else {
                showMessage(response?.data);
            }
        } catch (error) {
            console.error("Error updating password:", error);
            showMessage("The OTP entered is invalid.", "Please enter the otp recieved on registered email id");
        }

        setIsLoading(false);
    };

    const GenerateEmailUrl = (userInfo) => {
        // Encode the parameters using btoa
        const encodedEmail = btoa(userInfo.email); // Encodes the email
        const encodedIsAuthenticated = btoa("true"); // Encodes the isAuthenticated flag

        const queryParams = `?email=${encodedEmail}&isAuthenticated=${encodedIsAuthenticated}`;

        // Navigate to the reset-password route with query params
        navigate(`/reset-password${queryParams}`);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 col-md-12 px-0">
                    <div className="left-title-bg">
                        <p className="left-title">Set new password</p>
                    </div>
                    <div className="content tracking">
                        {/* <ReviewHeader /> */}
                        <p className="mb-0 font-20 font-md-30 font-weight-800">Set new password</p>
                        <p>
                            Set a new password to protect your account. Follow the security guidelines to ensure your
                            password is strong and safe.
                        </p>
                        <div className="align-center justify-content-center">
                            <div className="text-center w-100 pr-60 ">
                                <img src={getImageUrl("login-image.svg")} alt="img" className="w-100 mb-40 d-md-none" />

                                <h1 className="font-20 font-weight-600 my-25">
                                    {/* {otpRecieved ? '' : 'Verify User'} */}
                                </h1>
                                <span>
                                    <div
                                        onClick={() => {
                                            // dispatch(userActions.logout());
                                            window.location.href = `${window.location.origin}/forgot-password`;
                                        }}
                                        className="d-flex my-5"
                                    >
                                        <img
                                            src={getImageUrl("arrow-narrow-left.svg")}
                                            alt="img"
                                            className="mr-5 left-arrow cursor-pointer"
                                            onClick={() => {
                                                // dispatch(userActions.logout());
                                                window.location.href = `${window.location.origin}/forgot-password`;
                                            }}
                                        />
                                        <a
                                            onClick={() => {
                                                // dispatch(userActions.logout());
                                                window.location.href = `${window.location.origin}/forgot-password`;
                                            }}
                                            className="text-light-default font-weight-600  cursor-pointer"
                                        >
                                            Back to change your email address
                                        </a>
                                    </div>
                                </span>
                                <form id="forgot">
                                    <div className="row form-default">
                                        <div className="col-12 align-items-start col-md-8 login-field align-center text-left mb-3">
                                            <div className="mr-3">
                                                <img src={getImageUrl("icon-lock.svg")} alt="img" />
                                            </div>
                                            <div className="form-group">
                                                <label>Enter verification code</label>

                                                <input
                                                    aria-valuenow={"Enter verification code"}
                                                    style={{width: "335px"}}
                                                    id="verificationcode"
                                                    maxLength={7}
                                                    type="Number"
                                                    value={otpValue}
                                                    onChange={(e) => setOtpValue(e.target.value)}
                                                    name="verification-code"
                                                    className="form-control"
                                                    placeholder="Enter verification code"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                                            <div className="mr-3">
                                                <img src={getImageUrl("icon-lock.svg")} alt="img" />
                                            </div>

                                            <div className="form-group w-50">
                                                <label>New password</label>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "nowrap",
                                                        alignContent: "center",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <input
                                                        aria-valuenow={"New password"}
                                                        id="newPassword"
                                                        type={shownewpassword ? "text" : "password"}
                                                        value={newPassword}
                                                        onChange={handleNewPasswordChange}
                                                        name="new-password"
                                                        className="form-control"
                                                        placeholder="Enter new password"
                                                    />
                                                    {newPassword && (
                                                        <span
                                                            onClick={() => setShownewpassword(!shownewpassword)}
                                                            className="position-absolute end-0 top-50 translate-middle-y me-3 mx-2  cursor-pointer"
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            {
                                                                <img
                                                                    src={
                                                                        !shownewpassword
                                                                            ? getImageUrl("eye-close.svg")
                                                                            : getImageUrl("eye-open.svg")
                                                                    }
                                                                    alt="img"
                                                                />
                                                            }
                                                        </span>
                                                    )}
                                                </div>
                                                {passwordError && <p style={{color: "red"}}>{passwordError}</p>}
                                                <ul style={{marginTop: "10px", paddingLeft: "20px"}}>
                                                    <li style={{color: policies.length ? "green" : "red"}}>
                                                        At least 8 characters
                                                    </li>
                                                    <li style={{color: policies.uppercase ? "green" : "red"}}>
                                                        At least one uppercase letter
                                                    </li>
                                                    <li style={{color: policies.lowercase ? "green" : "red"}}>
                                                        At least one lowercase letter
                                                    </li>
                                                    <li style={{color: policies.digit ? "green" : "red"}}>
                                                        At least one digit
                                                    </li>
                                                    <li style={{color: policies.special ? "green" : "red"}}>
                                                        At least one special character
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>{" "}
                                        <div className="col-12 align-items-start col-md-8 login-field align-center mx-2 text-left mb-3">
                                            <div className="mr-3">
                                                <img src={getImageUrl("icon-lock.svg")} alt="img" />
                                            </div>
                                            <div className="form-group w-50">
                                                <label>Confirm password</label>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "nowrap",
                                                        alignContent: "center",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <input
                                                        aria-valuenow={"New password"}
                                                        id="confirmPassword"
                                                        type={showconfirmpassword ? "text" : "password"}
                                                        value={confirmPassword}
                                                        onChange={handleConfirmPasswordChange}
                                                        name="new-password"
                                                        className="form-control"
                                                        placeholder="Confirm your password"
                                                    />
                                                    <span
                                                        onClick={() => setShowconfirmpassword(!showconfirmpassword)}
                                                        className="position-absolute end-0 top-50 translate-middle-y me-3 mx-2  cursor-pointer"
                                                        style={{cursor: "pointer"}}
                                                    >
                                                        {
                                                            <img
                                                                src={
                                                                    !showconfirmpassword
                                                                        ? getImageUrl("eye-close.svg")
                                                                        : getImageUrl("eye-open.svg")
                                                                }
                                                                alt="img"
                                                            />
                                                        }
                                                    </span>
                                                </div>
                                                {confirmError && <p style={{color: "red"}}>{confirmError}</p>}
                                            </div>
                                        </div>
                                    </div>{" "}
                                    <div className="my-40 d-flex " style={{justifyContent: "space-around"}}>
                                        {/* <button type="button" className="btn btn-light prev-step px-45" onClick={() => setCurrentTab(1)}>
                               Back
                             </button> */}
                                        <button
                                            type="button"
                                            className="btn btn-default next-step px-30"
                                            disabled={
                                                isLoading ||
                                                (otpValue.length === 0 && !newPassword && !confirmPassword) ||
                                                confirmError
                                            }
                                            onClick={(e) => {
                                                handleSubmit(e);
                                            }}
                                        >
                                            {isLoading ? "Reseting..." : "Reset password"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="row form-default">
                            <div className="col-12 col-md-4">
                                <div className="form-group"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ReviewFooter />
            </div>
        </div>
    );
};
